import React from "react";
import { ReactSetStateBool, ReactSetStateString } from "./OTSM";

function useOtsmSelector(
  setOtsm: ReactSetStateBool,
  setOtsmDefault: ReactSetStateBool,
  setSuccess: ReactSetStateString
) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOtsm(event.target.checked);
    setSuccess((previous) => previous && "");
  };

  const handleChangeDefault = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOtsmDefault(event.target.checked);
  };

  return {
    handleChange,
    handleChangeDefault,
  };
}

export default useOtsmSelector;
